import { Component, Input, OnChanges, OnDestroy } from '@angular/core';
import { Subject } from 'rxjs';
import { GaChart } from './ga-chart';
import { GaService } from "../../../../services/site/ga.service";
import { CustomRangeParam, RangePresetParam } from "../../../../domain/stats";
import { EventService } from "../../../../services/event.service";
import {Program} from "../../../../domain/cloud-topology";
import {MatSnackBar} from "@angular/material/snack-bar";
import {COINCIDENT_PEAK} from "../../../../domain/constants";
import {takeUntil} from "rxjs/operators";
import moment from 'moment-timezone';

@Component({
    selector: 'app-ga-chart',
    templateUrl: './ga-chart.component.html',
    standalone: false
})
export class GaChartComponent implements OnChanges, OnDestroy {
  @Input() params: RangePresetParam | CustomRangeParam;
  @Input() chartId: string;
  @Input() holdUpdates: boolean;
  @Input() program: Program;
  @Input() timezone: string;
  gaChart: GaChart;

  noStats: boolean;
  loading: boolean;

  private componentDestroyed$ = new Subject<void>();

  constructor(private eventService: EventService,
              private gaService: GaService,
              private snackBar: MatSnackBar) {
    this.eventService.sideNavButton$.pipe(takeUntil(this.componentDestroyed$)).subscribe(() => this.gaChart.resize());
  }

  ngOnChanges() {
    if (!this.holdUpdates && this.params) {
      this.getGA();
    }
  }

  ngOnDestroy() {
    this.componentDestroyed$.next();
    this.componentDestroyed$.complete();
  }

  getGA() {
    this.loading = true;
    if (this.program.programType == COINCIDENT_PEAK) {
      if (this.program.properties.gridCode) {
        const timeWindow = this.getTimeWindow();
        if (timeWindow) {
          this.gaService.getCoincidentPeak(this.program, timeWindow.startDate, timeWindow.stopDate, "60").subscribe(data => {
            this.gaChart = new GaChart(this.chartId, data, this.program);
            this.loading = false;
            this.noStats = false;
          }, (err) => {
            this.noStats = true;
            this.loading = false;
            console.log(err);
          });
        }
      } else {
        this.snackBar.open(`Cannot get data for program ${this.program.name}: grid code not configured.`, "Close",
          {
            duration: 3000,
            horizontalPosition: "right",
            verticalPosition: "bottom"
          });
      }
    }
  }

  private getTimeWindow(): { startDate: string; stopDate: string } {
    if (this.timezone) {
      if (this.params['rangePreset'] ) {
        if (this.params['rangePreset'] == 'currentWindow') {
          return {
            startDate: moment().tz(this.timezone).subtract(1, 'days').startOf('day').utc().format('YYYY-MM-DDTHH:mm:ss'),
            stopDate: moment().tz(this.timezone).add(1, 'days').endOf('day').utc().format('YYYY-MM-DDTHH:mm:ss')
          };
        } else if(this.params['rangePreset'] == 'lastDay') {
          return {
            startDate: moment().tz(this.timezone).subtract(1, 'days').startOf('day').utc().format('YYYY-MM-DDTHH:mm:ss'),
            stopDate: moment().tz(this.timezone).subtract(1, 'days').endOf('day').utc().format('YYYY-MM-DDTHH:mm:ss')
          };
        } else if (this.params['rangePreset'] == 'last3days') {
          return {
            startDate: moment().tz(this.timezone).subtract(3, 'days').startOf('day').utc().format('YYYY-MM-DDTHH:mm:ss'),
            stopDate: moment().tz(this.timezone).subtract(1, 'days').endOf('day').utc().format('YYYY-MM-DDTHH:mm:ss')
          };
        } else if (this.params['rangePreset'] == 'lastWeek') {
          return {
            startDate: moment().tz(this.timezone).subtract(7, 'days').startOf('day').utc().format('YYYY-MM-DDTHH:mm:ss'),
            stopDate: moment().tz(this.timezone).subtract(1, 'days').endOf('day').utc().format('YYYY-MM-DDTHH:mm:ss')
          };
        }
      } else {
        return {
          startDate: moment(this.params['startDate']).tz(this.timezone).endOf('day').utc().format('YYYY-MM-DDTHH:mm:ss'),
          stopDate: moment(this.params['stopDate']).tz(this.timezone).subtract(1, 'days').endOf('day').utc().format('YYYY-MM-DDTHH:mm:ss')
        };
      }
    }

  }
}
